export const EqualIcon = () => {
  return (
    <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.301563 1.256V0.104H6.68556V1.256H0.301563ZM0.301563 4.584V3.448H6.68556V4.584H0.301563Z"
        fill="#525866"
      />
    </svg>
  );
};
